import styled from 'styled-components';

export default styled.section`
	position: relative;
	width: 100%;
	height: 100%;
	min-height: var(--px-100);
	.LoadingIndicator {
		width: 100% !important;
		height: 100% !important;
	}
	.ComponentFilterWrapper {
		display: flex;
		.ComponentFilter {
			margin-right: var(--px-20);
			margin-bottom: var(--px-24);
			button {
				border-radius: var(--px-8);
				border-color: var(--neutrals-300);
				width: var(--px-54) !important;
				height: var(--px-54) !important;
				background-color: var(--neutrals-00white);
				svg {
					fill: var(--neutrals-900);
					path {
						fill: var(--neutrals-900);
					}
				}
			}
		}
		.ComponentsSearchbox {
			margin-bottom: var(--px-24);
			.ComponentsSearchWrapper {
				width: var(--px-350);
			}
		}
		.ComponentsActions {
			margin-left: auto;
			display: flex;
			align-items: center;
			margin-bottom: var(--px-24);
			gap: var(--px-10);
		}
	}
	.ComponentOverviewContainer {
		display: flex;
		flex-direction: column;
		width: 100%;
		min-height: var(--px-150);
		height: auto;
		max-height: var(--px-3000);
		overflow-y: auto;
		padding-right: var(--px-5);
		margin-bottom: var(--px-24);
	}
	.paging {
		display: flex;
		align-items: center;
		margin-left: var(--px-20);
		margin-top: var(--px-20);
		justify-content: flex-end;
		.pagingShowtext {
			margin-left: auto;
			font-size: var(--px-14);
		}
		.StyledPagination {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-left: var(--px-10);
		}
	}
	.noComponentRecords {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		border-radius: var(--px-12);
		border: var(--px-1) solid var(--neutrals-200);
		background: var(--neutrals-00white);
		color: var(--neutrals-700);
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-24);
		margin-bottom: var(--px-16);
		min-height: var(--px-184);
	}
`;
